import React from 'react';
import {TextArea} from 'components/tt-forms/common';
import { Link, browserHistory } from 'react-router';
import { GiaiQuyetDonThu } from 'api';
import {ContainerFileDinhKem} from 'components/upload';
import moment from 'moment';
import { ShowIf } from 'components/utils';
import ConfirmDialog from './ConfirmDialog.jsx';
import { Toastr } from 'modules/toastr';
import { msg } from "constants/message";

const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'KIEM_TRA_DE_XUAT';

class CanBoKiemTraDeXuat extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      openDialog: false,
      showAttachFile: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTruongPhongTTXM: false,
      id: this.props.donId,
      donViId: '',
      yKienGiaiQuyet: '',
      dataGiaiQuyetDon: [],
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
      nextState: 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO',

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dataKiemTraDeXuat: this.props.dataKiemTraDeXuat
    }
  }

  componentWillMount() {
    this.determinativeVaiTro();
  }

  determinativeVaiTro() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (typeof userInfo == 'undefined') {
      browserHistory.push('/');
    } else {
      this.setState({
        donViId: userInfo.donViId
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataKiemTraDeXuat: nextProps.dataKiemTraDeXuat
    })
    this.checkFileRequired();
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    this.checkFileRequired()
  }

  checkFileRequired() {
    if(this.props.listTaiLieuVanThuKiemTraDeXuat) {
      let ListTaiLieuVanThu = this.props.listTaiLieuVanThuKiemTraDeXuat.filter(state => {
        return state.nguoiTaoInfo.donViId == this.state.donViId
      });
      let ListTaiLieuVanThuShow = this.props.listTaiLieuVanThuKiemTraDeXuat.filter(state => {
        return state.nguoiTaoInfo.donViId != this.state.donViId
      });

      if (ListTaiLieuVanThuShow.length > 0) {
        this.setState({
          listTaiLieuVanThuShow: ListTaiLieuVanThuShow
        })
      }

      let newArray = [...ListTaiLieuVanThu];
      if (newArray.length == 0) {
        let newItem = {
          ten: 'Báo cáo kết quả KTĐX',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'BC_KTDX'
        }
        this.setState({
          listTaiLieuVanThu: [
            ...ListTaiLieuVanThu,
            newItem
          ]
        }, ()=> {
          this.setState({
            showAttachFile: true
          })
        })
      } else {
        let dataCheck = newArray.filter(state => {
          return state.required && state.typeRequired == 'BC_KTDX'
        });
        if (dataCheck.length == 0) {
          let newItem = {
            ten: 'Báo cáo kết quả KTĐX',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'BC_KTDX'
          }
          this.setState({
            listTaiLieuVanThu: [
              ...ListTaiLieuVanThu,
              newItem
            ]
          }, ()=> {
            this.setState({
              showAttachFile: true
            })
          })
        } else {
          this.setState({
            listTaiLieuVanThu: ListTaiLieuVanThu
          }, ()=> {
            this.setState({
              showAttachFile: true
            })
          })
        }
      }
    }
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    });
  }

  getThongTinGiaiQuyetDon(id) {
    if(typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
      let params = {
        id: id
      };
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(res => {
        if(res.data) {
          this.setState({
            dataGiaiQuyetDon: res.data,
            yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : ''
          });
        }
      });
    }
  }

  onClickClose() {
    browserHistory.goBack();
  }

  getParams() {
    let dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;

    if(dataGiaiQuyetDon.donViThamTraXacMinhInfo) {
      dataGiaiQuyetDon.donViThamTraXacMinh = {
        id: dataGiaiQuyetDon.donViThamTraXacMinhInfo.coQuanQuanLyId
      }
    } else {
      dataGiaiQuyetDon.donViThamTraXacMinh = null
    }

    if(dataGiaiQuyetDon.canBoGiaiQuyetInfo) {
      dataGiaiQuyetDon.canBoGiaiQuyet = {
        id: dataGiaiQuyetDon.canBoGiaiQuyetInfo.congChucId
      }
    } else {
      dataGiaiQuyetDon.canBoGiaiQuyet = null
    }

    if(dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo) {
      dataGiaiQuyetDon.donViGiaoThamTraXacMinh = {
        id: dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.coQuanQuanLyId
      }
    } else {
      dataGiaiQuyetDon.donViGiaoThamTraXacMinh = null
    }

    if(dataGiaiQuyetDon.canBoThamTraXacMinhInfo) {
      dataGiaiQuyetDon.canBoThamTraXacMinh = {
        id: dataGiaiQuyetDon.canBoThamTraXacMinhInfo.congChucId
      }
    } else {
      dataGiaiQuyetDon.canBoThamTraXacMinh = null
    }

    if(dataGiaiQuyetDon.coQuanDieuTraInfo) {
      dataGiaiQuyetDon.coQuanDieuTra = {
        id: dataGiaiQuyetDon.coQuanDieuTraInfo.coQuanQuanLyId
      }
    } else {
      dataGiaiQuyetDon.coQuanDieuTra = null
    }

    // if(dataGiaiQuyetDon.coQuanTheoDoiInfo) {
    //   dataGiaiQuyetDon.coQuanTheoDoi = {
    //     id: dataGiaiQuyetDon.coQuanTheoDoiInfo.coQuanQuanLyId
    //   }
    // } else {
    //   dataGiaiQuyetDon.coQuanTheoDoi = null
    // }

    if(dataGiaiQuyetDon.truongDoanTTXMInfo) {
      dataGiaiQuyetDon.truongDoanTTXM = {
        id: dataGiaiQuyetDon.truongDoanTTXMInfo.congChucId
      }
    } else {
      dataGiaiQuyetDon.truongDoanTTXM = null
    }

    if(dataGiaiQuyetDon.canBoXuLyChiDinhInfo) {
      dataGiaiQuyetDon.canBoXuLyChiDinh = {
        id: dataGiaiQuyetDon.canBoXuLyChiDinhInfo.congChucId
      }
    } else {
      dataGiaiQuyetDon.canBoXuLyChiDinh = null
    }

    if(dataGiaiQuyetDon.nextStateInfo) {
      dataGiaiQuyetDon.nextState = {
        id: dataGiaiQuyetDon.nextStateInfo.id
      }
    } else {
      dataGiaiQuyetDon.nextState = null
    }

    if(dataGiaiQuyetDon.phongBanGiaiQuyetInfo) {
      dataGiaiQuyetDon.phongBanGiaiQuyet = {
        id: dataGiaiQuyetDon.phongBanGiaiQuyetInfo.coQuanQuanLyId
      }
    } else {
      dataGiaiQuyetDon.phongBanGiaiQuyet = null
    }

    delete dataGiaiQuyetDon['_links'];
    delete dataGiaiQuyetDon['nguoiSuaInfo'];
    delete dataGiaiQuyetDon['nguoiTaoInfo'];
    delete dataGiaiQuyetDon['ngaySua'];
    delete dataGiaiQuyetDon['ngayTao'];
    delete dataGiaiQuyetDon['donViThamTraXacMinhInfo'];
    delete dataGiaiQuyetDon['donViGiaoThamTraXacMinhInfo'];
    delete dataGiaiQuyetDon['canBoGiaiQuyetInfo'];
    delete dataGiaiQuyetDon['canBoThamTraXacMinhInfo'];
    delete dataGiaiQuyetDon['coQuanDieuTraInfo'];
    delete dataGiaiQuyetDon['coQuanTheoDoiInfo'];
    delete dataGiaiQuyetDon['nguoiBanHanhInfo'];
    delete dataGiaiQuyetDon['truongDoanTTXMInfo'];
    delete dataGiaiQuyetDon['donId'];
    delete dataGiaiQuyetDon['phongBanGiaiQuyetInfo'];
    delete dataGiaiQuyetDon['canBoXuLyChiDinhInfo'];
    delete dataGiaiQuyetDon['nextStateInfo'];

    dataGiaiQuyetDon['don'] = {
      id: this.state.id
    }

    return dataGiaiQuyetDon;
  }

  handleSave(){
    if (this.validateSubmitForm()) {
      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      this.state.dataFileDinhKem.map((item, i) => {
        if (item.taiLieuVanThuId) {
          this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
            don: {
              id: Number(this.state.id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: item.loaiTepDinhKem,
            loaiQuyTrinh: item.loaiQuyTrinh,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        } else {
          this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
            don: {
              id: Number(this.state.id)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: loaiTepDinhKem,
            loaiQuyTrinh: loaiQuyTrinh,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        }
      });

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      let params = this.getParams();

      params.yKienGiaiQuyet = this.state.yKienGiaiQuyet;
      this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
        this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
          this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
            this.saveGiaiQuyetDon(params, 'gqdLuu');
          });
        });
      });
    }
  }

  handleGiaiQuyetDon() {
    if (this.validateSubmitForm()) {
      this.state.dataFileDinhKem.map((item, i) => {
        if (item.taiLieuVanThuId) {
          this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
            don: {
              id: Number(this.state.id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: item.loaiTepDinhKem,
            loaiQuyTrinh: item.loaiQuyTrinh,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        } else {
          this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
            don: {
              id: Number(this.state.id)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: loaiTepDinhKem,
            loaiQuyTrinh: loaiQuyTrinh,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        }
      });

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      let selectedState = this.props.listNextStates.filter(state => {
        return state.type == this.state.nextState
      });

      let params = {
        thongTinGiaiQuyetDon: {
          id: Number(this.state.thongTinGiaiQuyetDonId)
        },
        nextState: {
          id: Number(selectedState[0].stateId)
        },
        yKienGiaiQuyet: this.state.yKienGiaiQuyet
      }
      this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
        this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
          this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
            this.postGiaiQuyetDon(params, 'ktdxTraBaoCao');
          });
        });
      });
    }
  }

  onFileChange(data) {
    this.setState ({
      dataFileDinhKem: data
    });
  }

  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  onFileRemove(id, data) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });
    this.setState ({
      dataFileDinhKem: data
    });


  }

  validateSubmitForm() {
    let pass = true;
    if (this.state.dataFileDinhKem.length > 0) {
      this.props.validators['formTaoDon'].map(validator => {
        if(pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
    }
    return pass;
  }

  componentWillUnmount() {

  }

  openDialog(name) {
    if (this.validateSubmitForm()) {
      this.setState({
        openDialog: true
      })
    }
  }

  closeDialog() {
    this.setState({
      openDialog: false
    })
  }

  onSuccess(name) {
    this.setState({
      openDialog: false
    });
    this.handleGiaiQuyetDon();
  }

  updateGiaiQuyetDon(params, _params, message) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.state.thongTinGiaiQuyetDonId},params).then(res => {
      this.postGiaiQuyetDon(_params, message);
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  saveGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.state.thongTinGiaiQuyetDonId},params).then(res => {
      this.onClickClose();
      Toastr(message ? msg[message] : msg.luuGiaiQuyetDonThanhCong, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(res => {
      this.onClickClose();
      Toastr(message ? msg[message] : msg.giaiQuyetDon, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  render() {
    let tenCoQuan = (this.props.thongTinYeuCauKiemTraDeXuat && this.props.thongTinYeuCauKiemTraDeXuat.donViGiaoKTDX) ? this.props.thongTinYeuCauKiemTraDeXuat.donViGiaoKTDX.ten : '';
    let lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    return (
      <div className="items-form">
        <div className="row pl10 pr10">
          <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="" />
        </div>
        <ShowIf condition={this.state.showAttachFile}>
          <div className="container-filedinhkem pb5">
            <ContainerFileDinhKem onSave={this.props.onSave} label="Danh sách văn bản xử lý" bindValidator={this} dataShow={this.state.listTaiLieuVanThuShow} data={this.state.listTaiLieuVanThu} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
          </div>
        </ShowIf>
        <div className='col-100 no-gutter'>
          <div className='wrap-gqd-kqt'>
            <div className="box-bottom gqd-wrap col-100 mt20 pt30">
              <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline') : "btn-action btn-move action-todo"} onClick={this.openDialog.bind(this)}><span>Chuyển đơn vị giải quyết</span></Link>
              <ConfirmDialog open={this.state.openDialog} onClose={this.closeDialog.bind(this)} onSuccess={this.onSuccess.bind(this)} title={"Xác nhận giao "+lb1} content={'Bạn có đồng ý chuyển cho ' + tenCoQuan + ' báo cáo kiểm tra và để xuất của đơn/vụ việc này không?'} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CanBoKiemTraDeXuat.defaultProps = {
  validators: {},
  onSave: false
}

export default CanBoKiemTraDeXuat;


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-kiem-tra-de-xuat/chuyen-vien/CanBoKiemTraDeXuat.jsx